import { Routes } from '@angular/router';

import { MapTrafficComponent } from './map-traffic/map-traffic.component';



export const routes: Routes = [
    { path: 'map/bplocation/:s', component: MapTrafficComponent },
    { path: 'map/bplocation/:s/:x/:y', component: MapTrafficComponent },
    { path: '**', redirectTo: '/map/bplocation/w' },
];
